export const serverIp = "https://karobarbepesh.smartdemo.live";
export const gpuserverIp = "https://medianestpwbegpu.smartdemo.live/";

// Instagram webhook URL
export const INSTAGRAM_WEBHOOK_URL =
  "https://merapeshawar.app.n8n.cloud/webhook/Peshawar-instagram-agent";

// Facebook webhook URL
export const FACEBOOK_WEBHOOK_URL =
  "https://merapeshawar.app.n8n.cloud/webhook/peshawar-facebook-agent";

// YouTube webhook URL
export const YOUTUBE_WEBHOOK_URL =
  "https://merapeshawar.app.n8n.cloud/webhook/mera-peshawar-youtube-agent";

export const HEYGEN_SPEAKERS = {
  male: {
    avatar_id: "f496c84a463347628e57ae5656807517",
    voice_id: "sadachbia",
    voice_id_urdu: "sadachbia",
    img: "male_news_anchor_1.png",
    label: "Voice 1 (Male)",
  },

  male1: {
    avatar_id: "de657c0a941441fcb3df0bdcccb63a54",
    voice_id: "sadaltager",
    voice_id_urdu: "sadaltager",
    img: "male_news_anchor_2.png",
    label: "Voice 2 (Male)",
  },

  male2: {
    avatar_id: "044ee413f13743b282d23da2a8f02841",
    voice_id: "Zubenelgenubi",
    voice_id_urdu: "Zubenelgenubi",
    img: "male_news_anchor_3.png",
    label: "Voice 3 (Male)",
  },

  // FEMALE
  female: {
    avatar_id: "e2ea6724c6e9432b9bd19eb6bf7278c9",
    voice_id: "kore",
    voice_id_urdu: "kore",
    img: "female_news_anchor_1.png",
    label: "Voice 1 (Female)",
  },

  female1: {
    avatar_id: "9849ebc511c9471389e94d7fbb1b80dd",
    voice_id: "Sulafat",
    voice_id_urdu: "Sulafat",
    img: "female_news_anchor_2.png",
    label: "Voice 2 (Female)",
  },

  female2: {
    avatar_id: "f57468fcbbb94d0a8aecaf44f07ff41a",
    voice_id: "Zephyr",
    voice_id_urdu: "Zephyr",
    img: "female_news_anchor_3.png",
    label: "Voice 3 (Female)",
  },
};

// Helper function to get voice_id based on language
export const getVoiceIdByLanguage = (
  speakerKey: string,
  language: string = "English",
): string => {
  const speaker = HEYGEN_SPEAKERS[speakerKey];
  if (!speaker) return "";

  const isUrdu = language.toLowerCase() === "urdu";
  return isUrdu && speaker.voice_id_urdu
    ? speaker.voice_id_urdu
    : speaker.voice_id;
};

// Helper function to get speaker with language-specific voice_id
export const getSpeakerByLanguage = (
  speakerKey: string,
  language: string = "English",
) => {
  const speaker = HEYGEN_SPEAKERS[speakerKey];
  if (!speaker) return null;

  const isUrdu = language.toLowerCase() === "urdu";
  return {
    ...speaker,
    voice_id:
      isUrdu && speaker.voice_id_urdu
        ? speaker.voice_id_urdu
        : speaker.voice_id,
  };
};

export const ELEVENLABS_SPEAKERS = {
  english: {
    Mcaster: "ash",
    Male1: "ash",
    Male2: "ash",
    Male3: "ash",
    Male4: "ash",
    Male5: "ash",
    Fcaster: "nova",
    Female2: "nova",
    Female3: "nova",
    Female4: "nova",
    Female5: "nova",
    Female6: "nova",
  },
  arabic: {
    Mcaster: "ash",
    Male1: "ash",
    Male2: "ash",
    Male3: "ash",
    Male4: "ash",
    Male5: "ash",
    Fcaster: "nova",
    Female2: "nova",
    Female3: "nova",
    Female4: "nova",
    Female5: "nova",
    Female6: "nova",
  },
};

// export const ELEVENLABS_SPEAKERS = {
//   english: { Mcaster: "ZXb5DL5wDkGP8tqFQOEQ", Fcaster: "3D8zrcmnWpgtme9H9bI0" },
//   arabic: { Mcaster: "UGXEaqKwClvNPorudbMD", Fcaster: "f415hsstsNSr4Wi60NTs" },
// };

export const formatMinutesSeconds = (timeInMinutes) => {
  let minutes = Math.floor(timeInMinutes);
  let seconds = Math.round((timeInMinutes - minutes) * 60);
  if (seconds === 60) {
    minutes++;
    seconds = 0;
  }
  return `${minutes}m ${seconds}s`;
};
